var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75729 4.75736C4.36676 5.14788 4.36676 5.78105 4.75729 6.17157L7.58572 9L4.75729 11.8284C4.36676 12.219 4.36676 12.8521 4.75729 13.2426C5.14781 13.6332 5.78098 13.6332 6.1715 13.2426L8.99993 10.4142L11.8284 13.2426C12.2189 13.6332 12.852 13.6332 13.2426 13.2426C13.6331 12.8521 13.6331 12.219 13.2426 11.8284L10.4141 9L13.2426 6.17157C13.6331 5.78105 13.6331 5.14788 13.2426 4.75736C12.852 4.36684 12.2189 4.36683 11.8284 4.75736L8.99993 7.58579L6.1715 4.75736C5.78098 4.36684 5.14781 4.36684 4.75729 4.75736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBold);
export default __webpack_public_path__ + "static/media/cross-bold.5ffb3386246f8dc5aac75b0b30a20f7e.svg";
export { ForwardRef as ReactComponent };